export default "__VITE_ASSET__Chu0C1o5__"